import React from 'react'
import { useRoute } from '@react-navigation/native'
import { Header, Screen, BackButtonWeb } from '@components'
import { useAddGhostContact } from './hooks'
import AddGhostForm from './components/AddGhostForm'
import { useGetProfileById } from '@hooks'
import { useLanguage } from '@context'

const AddGhostContact: React.FC = () => {
  const { t } = useLanguage()
  const route: any = useRoute()
  const profileId = route.params?.profileId

  const { data: profile } = useGetProfileById(profileId)

  const { formData, handleSave, handleFormChange } = useAddGhostContact(profile)
  const isEdit = profile

  return (
    <Screen>
      <BackButtonWeb title={isEdit ? t('form.backToProfile') : t('form.backToContacts')} />
      <Header
        title={isEdit ? t('form.editGhostProfile') : t('form.createGhostProfile')}
        /*iconLeft="arrowBack"
        iconColor={theme.colors.secondary}
        onPressLeft={() => {
          if (isModalContext && props?.onBack) {
            props.onBack()
          } else {
            navigation?.goBack()
          }
        }}*/
      />

      <AddGhostForm
        handleSave={handleSave}
        handleFormChange={handleFormChange}
        formData={formData}
        profile={profile}
      />
    </Screen>
  )
}

export default AddGhostContact
